import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/AIHeuristicCard/algorithmCard/card_arrow.png';
const _withScopeId = n => (_pushScopeId("data-v-f26ee1c6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "algorithm-card"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "download-icon",
  src: _imports_0
}, null, -1));
const _hoisted_4 = {
  class: "category-type"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "font10"
};
const _hoisted_7 = {
  class: "bottom"
};
const _hoisted_8 = {
  class: "font10 titleEn"
};
const _hoisted_9 = {
  class: "font10"
};
const _hoisted_10 = {
  class: "top-background"
};
const _hoisted_11 = {
  class: "content"
};
const _hoisted_12 = {
  class: "title"
};
const _hoisted_13 = {
  class: "font10"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "subTitle"
}, "【算法原理】", -1));
const _hoisted_15 = {
  class: "font10"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "subTitle"
}, "【相关应用】", -1));
const _hoisted_17 = {
  class: "font10"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "algorithm-card-item",
      key: index
    }, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.categoryType, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "category-type-item",
        key: index
      }, [_createElementVNode("img", {
        src: $setup.handleCategory(item).imgUrlActive
      }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, _toDisplayString($setup.handleCategory(item).label), 1)]);
    }), 128))])]), _createElementVNode("div", {
      class: "center",
      style: _normalizeStyle({
        backgroundImage: `url(${item.imgUrl})`
      })
    }, null, 4), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(item.titleEn), 1), _createElementVNode("p", _hoisted_9, _toDisplayString(item.describe), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", null, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(item.titleEn), 1)]), _createElementVNode("div", null, [_hoisted_14, _createElementVNode("p", _hoisted_15, _toDisplayString(item.principle), 1)]), _createElementVNode("div", null, [_hoisted_16, _createElementVNode("p", _hoisted_17, _toDisplayString(item.application), 1)])])])]);
  }), 128))]);
}